/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PermissionCatalogProductView } from '../models/PermissionCatalogProductView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PermissionsService {
    /**
     * Get permission catalog (all products and their permission keys)
     * @returns PermissionCatalogProductView Permission catalog
     * @throws ApiError
     */
    public static getAppPermissionCatalog(): CancelablePromise<Array<PermissionCatalogProductView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/permission-catalog',
        });
    }
}
